import copyrightLocales from "@/lib/localization/Copyright.locales";
import {
  Caption,
  FormatUtils,
  LocaleDictionaryType,
  useLanguage,
  useLocales,
} from "@/lib/main";

type Props = {
  companyName?: LocaleDictionaryType;
};

export default function Copyright({ companyName }: Props) {
  const l = useLocales();
  const { language } = useLanguage();
  const year = new Date().getFullYear();
  const displayYear =
    language === "ar" ? FormatUtils.formatInEasternArabicNumerals(year) : year;

  return (
    <a
      href="https://crescentapplications.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Caption color="always-light" fontWeight={400} textAlign="center">
        {l(copyrightLocales.copyright)}
        {" "}
        {displayYear}{" "}
        {companyName
          ? l(companyName)
          : l(copyrightLocales.crescentApplications)}{" "}
        {l(copyrightLocales.allRightsReserved)}
      </Caption>
    </a>
  );
}
